import { MNHotInstance } from '../../tableHotInstanceTypes';

/**
 * Returns whether the Handsontable instance is still safe to use.
 */
export const isHotInstanceAvailable = (hotInstance?: MNHotInstance | null): hotInstance is MNHotInstance =>
    !!hotInstance && !hotInstance.isDestroyed;
